import de from './de.json'
// import en from './en.json'

const messages: Record<string, Record<string, string>> = { de }
const defaultLang = 'de'
const availableLang = ['de']

export { messages, defaultLang, availableLang }
